/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Publish_ChangesInputs */

const en_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to publish changes`)
};

const es_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al publicar los cambios`)
};

const fr_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la publication des modifications`)
};

const de_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Veröffentlichen der Änderungen`)
};

const ja_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更の公開に失敗しました`)
};

const zh_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布更改失败`)
};

const ar_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل في نشر التغييرات`)
};

const id_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menerbitkan perubahan`)
};

const it_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile pubblicare le modifiche`)
};

const ru_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось опубликовать изменения`)
};

const pt_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao publicar as alterações`)
};

const ko_failed_to_publish_changes = /** @type {(inputs: Failed_To_Publish_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 사항을 게시하지 못했습니다`)
};

/**
* | output |
* | --- |
* | "Failed to publish changes" |
*
* @param {Failed_To_Publish_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_publish_changes = /** @type {((inputs?: Failed_To_Publish_ChangesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Publish_ChangesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_publish_changes(inputs)
	if (locale === "es") return es_failed_to_publish_changes(inputs)
	if (locale === "fr") return fr_failed_to_publish_changes(inputs)
	if (locale === "de") return de_failed_to_publish_changes(inputs)
	if (locale === "ja") return ja_failed_to_publish_changes(inputs)
	if (locale === "zh") return zh_failed_to_publish_changes(inputs)
	if (locale === "ar") return ar_failed_to_publish_changes(inputs)
	if (locale === "id") return id_failed_to_publish_changes(inputs)
	if (locale === "it") return it_failed_to_publish_changes(inputs)
	if (locale === "ru") return ru_failed_to_publish_changes(inputs)
	if (locale === "pt") return pt_failed_to_publish_changes(inputs)
	return ko_failed_to_publish_changes(inputs)
});